// 全局 G2 设置
import { track, setTheme } from 'bizcharts';

track(false);

const config = {
  defaultColor: '#1089ff',
  shape: {
    interval: {
      fillOpacity: 1,
    },
  },
};

setTheme(config);



// WEBPACK FOOTER //
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/src/components/Charts/g2.js